import React, { useEffect, useState } from "react";
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_kratos';
import moment from 'moment';

const TOP_KPIS_FIRST_PAGE = {
  totalvehiclecount: 0,
  doc_count: 0,
  InterruptDurationInMin_count: 0,
  Full_cycles: 0,
  Faulty_cycles: 0,
  opportunity_cycles: 0,
  totChrgdVec: 0,
};

export default function ChargingFirstPageKpis_Kratos({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [totalChargedVechicles, setTotalChargedVechicles] = useState(TOP_KPIS_FIRST_PAGE);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        totalvehiclecount: temp_result[0].total_vehicle_count.value
      }
      setTopData((prestate) => responce);
    }
  }

  const faultActive = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        doc_count: temp_result.aggregations.groupby.buckets[0].doc_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        InterruptDurationInMin_count: temp_result.aggregations.groupby.buckets[0].InterruptDurationInMin_count.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        Full_cycles: temp_result.aggregations.groupby.buckets[0].Full_cycles.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        Faulty_cycles: temp_result.aggregations.groupby.buckets[0].Faulty_cycles.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunity_cycles: temp_result.aggregations.groupby.buckets[0].opportunity_cycles.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),

        // fault_active_duration: temp_result.hits.total.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 
        // faulty: temp_result.aggregations.groupby.buckets[0].Faulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // faultyslow: temp_result.aggregations.groupby.buckets[0].slowFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // faultyfast: temp_result.aggregations.groupby.buckets[0].fastFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // opportunitycharged: temp_result.aggregations.groupby.buckets[0].Opportunity.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // opportunityslow: temp_result.aggregations.groupby.buckets[0].OpportunitySlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // opportunityfast: temp_result.aggregations.groupby.buckets[0].OpportunityFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // fullcharged: temp_result.aggregations.groupby.buckets[0].Full.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // fullchargedslow: temp_result.aggregations.groupby.buckets[0].FullSlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // fullchargedfast: temp_result.aggregations.groupby.buckets[0].FullFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // totalcharged: temp_result.aggregations.groupby.buckets[0].doc_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // totalslow: temp_result.aggregations.groupby.buckets[0].slow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        // totalfast: temp_result.aggregations.groupby.buckets[0].fast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      }
      setFaultActive((prestate) => responce);
    }
  }

  const totalChargedVehiclesRes = (data) => {
    const res = data;
    let responce = {};
    if (res.length != 0) {
      let temp_result = res;
      responce = {
        totChrgdVec: temp_result[0].driven_vehicle_count.value
      }
      setTotalChargedVechicles((prestate) => responce);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "kratos_charge/topkpisfirstpage", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "kratos_charge/totalchargedcycle", body: { filterdata: gloablfilter } }, faultActive)
    fetchData({ url: API_URL_MAIN + "kratos_charge/totalChargedVehicles", body: { filterdata: gloablfilter } }, totalChargedVehiclesRes)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  // code for pop up
  const appyDataModal = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  }
  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };
  const handlePlatformChange = (event) => {
    const toggel = event.target.value
    if (toggel === "optioncharging")
      fetchData({ url: API_URL_MAIN + "kratos_charge/pop_up_one", body: { filterdata: gloablfilter } }, appyDataModal)
    else
      fetchData({ url: API_URL_MAIN + "kratos_charge/pop_up_one_outlier", body: { filterdata: gloablfilter } }, appyDataModal)

  }
  const [toShowRadio, setToShowRadio] = useState("totChrgCycle")
  const [currentRadioValue, setCurrentRadioValue] = useState("optioncharging")
  const [modaldata, setModaldata] = useState([]);
  const loadModalData = (event) => {
    const dataTag = event.currentTarget.dataset.tag;
    setToShowRadio(dataTag)
    setCurrentRadioValue("optioncharging")
    fetchData({ url: API_URL_MAIN + "kratos_charge/pop_up_one", body: { filterdata: gloablfilter, dataTag: dataTag } }, appyDataModal)
  }
  // code for pop up
  return (
    <>
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              {
                toShowRadio === "totChrgCycle" ?
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-check form-check-inline">
                        <input className="form-check-input_kratos" type="radio" name="inlineRadioOptionsCharging" id="inlineRadio1" value="optioncharging" checked={currentRadioValue === 'optioncharging'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                        <label className="form-check-label" htmlFor="inlineRadio1">&nbsp; Charged Cycles</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input_kratos" type="radio" name="inlineRadioOptionsOutlires" id="inlineRadio2" value="optionoutliers" checked={currentRadioValue === 'optionoutliers'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                        <label className="form-check-label" htmlFor="inlineRadio2">&nbsp; Outliers</label>
                      </div>
                    </div>
                  </div>
                  :
                  <h5 className="modal-title" id="exampleModalLabel">{toShowRadio === "criticalFaultyCycle" ? (<>Critical Faulty cycles</>) : (<>Interruption cycles</>)}</h5>
              }
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead className="popUpTable">
                    <tr>
                      {
                        toShowRadio === "totChrgCycle" ? (<>
                          <th scope="col">Cycle</th>
                          <th scope="col">Gun Start</th>
                          <th scope="col">Gun End</th>
                          <th scope="col">GunDurationInMin</th>
                          <th scope="col">gunAfterfullchargeInMin</th>
                          <th scope="col">Soc Start</th>
                          <th scope="col">Soc End</th>
                          <th scope="col">delta_soc</th>
                          <th scope="col">chargeDurationInMin</th>
                          <th scope="col">roc</th>
                          <th scope="col">kwhCharged</th>
                          <th scope="col">fistChargeTime</th>
                          <th scope="col">LastChargeTime</th>
                          <th scope="col">avgChargingCurrent</th>
                          <th scope="col">KWh_Remain_start</th>
                          {/* <th scope="col">B_KWh_Remain_start</th> */}
                          {/* <th scope="col">C_KWh_Remain_start</th> */}
                          {/* <th scope="col">D_KWh_Remain_start</th> */}
                          <th scope="col">KWh_Remain_end</th>
                          {/* <th scope="col">B_KWh_Remain_end</th> */}
                          {/* <th scope="col">C_KWh_Remain_end</th> */}
                          {/* <th scope="col">D_KWh_Remain_end</th> */}
                          <th scope="col">Max_Cell_Temp</th>
                          {/* <th scope="col">B_Max_Cell_Temp</th> */}
                          {/* <th scope="col">C_Max_Cell_Temp</th> */}
                          {/* <th scope="col">D_Max_Cell_Temp</th> */}
                          <th scope="col">Min_Cell_Volt</th>
                          {/* <th scope="col">B_Min_Cell_Volt</th> */}
                          {/* <th scope="col">C_Min_Cell_Volt</th> */}
                          {/* <th scope="col">D_Min_Cell_Volt</th> */}
                          <th scope="col">Max_Cell_Volt</th>
                          {/* <th scope="col">B_Max_Cell_Volt</th> */}
                          {/* <th scope="col">C_Max_Cell_Volt</th> */}
                          {/* <th scope="col">D_Max_Cell_Volt</th> */}
                          <th scope="col">signal_occurence_count</th>
                          <th scope="col">signal_occurence_name</th>
                          <th scope="col">NoOfInterrupt</th>
                          <th scope="col">InterruptDurationInMin</th>
                          <th scope="col">LOB</th>
                          <th scope="col">PL</th>
                          <th scope="col">PPL</th>
                          <th scope="col">DLR_ORG_CITY</th>
                          <th scope="col">vehicle_registration_number</th>
                          {/* <th scope="col">Depot_Name</th> */}
                          <th scope="col">eventdate</th></>)
                          :
                          (<><th scope="col">Cycle</th>
                            <th scope="col">Gun Start</th>
                            <th scope="col">Gun End</th>
                            <th scope="col">{toShowRadio !== "criticalFaultyCycle" ? (<>NoOfInterrupt</>) : (<>signal_occurence_count</>)}</th>
                            <th scope="col">{toShowRadio !== "criticalFaultyCycle" ? (<>InterruptDurationInMin</>) : (<>faultName</>)}</th>
                          </>
                          )
                      }
                    </tr>
                  </thead>
                  <tbody>

                    {isLoading ? loader : (modaldata.length == 0) ? <tr><td colSpan='17' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata.map((x, index) => {
                      return (<tr key={index}>
                        {
                          toShowRadio === "totChrgCycle" ? (<>
                            <td scope="row">{index + 1}</td>
                            <td scope="row">{x._source.gun_start}</td>
                            <td scope="row">{x._source.gun_end}</td>
                            <td scope="row">{x._source.gunDurationInMin}</td>
                            <td scope="row">{x._source.gunAfterfullchargeInMin}</td>
                            <td scope="row">{x._source.soc_start}</td>
                            <td scope="row">{x._source.soc_end}</td>
                            <td scope="row">{x._source.delta_soc}</td>
                            <td scope="row">{x._source.chargeDurationInMin}</td>
                            <td scope="row">{x._source.roc}</td>
                            <td scope="row">{x._source.kwhCharged}</td>
                            <td scope="row">{x._source.fistChargeTime}</td>
                            <td scope="row">{x._source.LastChargeTime}</td>
                            <td scope="row">{x._source.avgChargingCurrent}</td>
                            <td scope="row">{x._source.KWh_Remain_start}</td>
                            {/* <td scope="row">{x._source.B_KWh_Remain_start}</td> */}
                            {/* <td scope="row">{x._source.C_KWh_Remain_start}</td> */}
                            {/* <td scope="row">{x._source.D_KWh_Remain_start}</td> */}
                            <td scope="row">{x._source.KWh_Remain_End}</td>
                            {/* <td scope="row">{x._source.B_KWh_Remain_End}</td> */}
                            {/* <td scope="row">{x._source.C_KWh_Remain_End}</td> */}
                            {/* <td scope="row">{x._source.D_KWh_Remain_End}</td> */}
                            <td scope="row">{x._source.Max_Cell_Temp}</td>
                            {/* <td scope="row">{x._source.B_Max_Cell_Temp}</td> */}
                            {/* <td scope="row">{x._source.C_Max_Cell_Temp}</td> */}
                            {/* <td scope="row">{x._source.D_Max_Cell_Temp}</td> */}
                            <td scope="row">{x._source.A_Min_Cell_Volt}</td>
                            {/* <td scope="row">{x._source.B_Min_Cell_Volt}</td> */}
                            {/* <td scope="row">{x._source.C_Min_Cell_Volt}</td> */}
                            {/* <td scope="row">{x._source.D_Min_Cell_Volt}</td> */}
                            <td scope="row">{x._source.A_Max_Cell_Volt}</td>
                            {/* <td scope="row">{x._source.B_Max_Cell_Volt}</td> */}
                            {/* <td scope="row">{x._source.C_Max_Cell_Volt}</td> */}
                            {/* <td scope="row">{x._source.D_Max_Cell_Volt}</td> */}
                            <td scope="row">{x._source.signal_occurence_count}</td>
                            <td scope="row" className="text-start">{x._source.signal_occurence_name}</td>
                            <td scope="row">{x._source.NoOfInterrupt}</td>
                            <td scope="row">{x._source.InterruptDurationInMin}</td>
                            <td scope="row">{x._source.LOB}</td>
                            <td scope="row">{x._source.PL}</td>
                            <td scope="row">{x._source.PPL}</td>
                            <td scope="row">{x._source.DLR_ORG_CITY}</td>
                            <td scope="row">{x._source.vehicle_registration_number}</td>
                            {/* <td scope="row">{x._source.Depot_Name}</td> */}
                            <td scope="row">{x._source.eventdate}</td></>)
                            :
                            (<>
                              <td scope="row">{index + 1}</td>
                              <td scope="row">{x._source.gun_start}</td>
                              <td scope="row">{x._source.gun_end}</td>
                              <td scope="row">{toShowRadio !== "criticalFaultyCycle" ? x._source.NoOfInterrupt : x._source.signal_occurence_count}</td>
                              {/* className="text-start" */}
                              <td scope="row">{toShowRadio !== "criticalFaultyCycle" ? x._source.InterruptDurationInMin : x._source.signal_occurence_name}</td>
                            </>)
                        }
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="kpi my-3">
        <div className="row">

          <div className="col-md-12 col-sm-12 col-12 col-lg-12 pl-4">
            <div className="row equal-cols">
              <div className="col-md-4 col-sm-12 col-lg-2 pl-0" style={{ paddingLeft: "6px" }}>
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (
                    <>
                      <div className="widgetIcon">
                        <img src={"../../../assets/img_Bus/CESL_Charging/total_charged_vehicles.png"} />
                      </div>
                      <div className="ps-3">
                        <p className="h5 m-0 highBold">{topdata.totalvehiclecount}|{totalChargedVechicles.totChrgdVec}</p>
                        <p className="m-0 mt-1"><small className="text-mutedf">Total<b>|</b>Charged vehicles</small></p>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="col-md-4 col-sm-12 col-lg-2 pl-0 evtpks-pl0 ">
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/CESL_Charging/total_charged_cycles.png"} /> </div>
                    <div className="ps-3" data-tag="totChrgCycle"
                      data-bs-toggle={gloablfilter.VIN_NUM.length === 1 ? "modal" : undefined}
                      data-bs-target={gloablfilter.VIN_NUM.length === 1 ? "#staticBackdrop" : undefined}
                      style={gloablfilter.VIN_NUM.length === 1 ? { cursor: "pointer" } : undefined}
                      onClick={gloablfilter.VIN_NUM.length === 1 ? loadModalData : undefined}
                    >
                      <p className="h5 m-0 highBold">{faultactive.doc_count}</p>
                      <p className="m-0"><small className="text-mutedf">Total charged cycles</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-2 pl-0 evtpks-pl0 ">
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/CESL_Charging/vehicle_with_fault.png"} /> </div>
                    <div className="ps-3" data-tag="criticalFaultyCycle"
                      data-bs-toggle={gloablfilter.VIN_NUM.length === 1 ? "modal" : undefined}
                      data-bs-target={gloablfilter.VIN_NUM.length === 1 ? "#staticBackdrop" : undefined}
                      style={gloablfilter.VIN_NUM.length === 1 ? { cursor: "pointer" } : undefined}
                      onClick={gloablfilter.VIN_NUM.length === 1 ? loadModalData : undefined}
                    >
                      <p className="h5 m-0 highBold">{faultactive.Faulty_cycles}</p>
                      <p className="m-0"><small className="text-mutedf">Critical faulty cycles</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-2 pl-0 evtpks-pl0 ">
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/CESL_Charging/Interruption_cycles.png"} /> </div>
                    <div className="ps-3" data-tag="interruptionCycle"
                      data-bs-toggle={gloablfilter.VIN_NUM.length === 1 ? "modal" : undefined}
                      data-bs-target={gloablfilter.VIN_NUM.length === 1 ? "#staticBackdrop" : undefined}
                      style={gloablfilter.VIN_NUM.length === 1 ? { cursor: "pointer" } : undefined}
                      onClick={gloablfilter.VIN_NUM.length === 1 ? loadModalData : undefined}
                    >
                      <p className="h5 m-0 highBold">{faultactive.InterruptDurationInMin_count}</p>
                      <p className="m-0"><small className="text-mutedf">Interruption cycles</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-2 pl-0 evtpks-pl0 ">
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/CESL_Charging/opportunity_charged_cycles.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{faultactive.opportunity_cycles}</p>
                      <p className="m-0"><small className="text-mutedf">Opportunity charged cycles</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-2 pl-0 evtpks-pl0 ">
                <div className="widget_kratos p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/CESL_Charging/full_charged_cycles.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{faultactive.Full_cycles}</p>
                      <p className="m-0"><small className="text-mutedf">Full charged cycles</small></p>
                    </div></>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
